<agm-map [fitBounds]="true" 
  class="agm-map" 
  [styles]="styles"
  (mapClick)="close_window()"
  #mapElement>

  <agm-marker *ngFor="let step of visibleSteps; let i = index" 
    (markerClick)="clickedMarker(infowindow)"
    [latitude]="step.latitude" 
    [longitude]="step.longitude" 
    [agmFitBounds]="true"
    [iconUrl]="markerIcon"
    [label]="{ text: (i + 1).toString() }" 
    [zIndex]="i" 
    [title]="step.city_name">

    <agm-info-window #infowindow>{{ step.city_name }}</agm-info-window>
  </agm-marker>

  <agm-polyline [strokeColor]="lineColor">
    <agm-polyline-point *ngFor="let step of visibleSteps" 
      [latitude]="+step.latitude"
      [longitude]="+step.longitude">
    </agm-polyline-point>
  </agm-polyline>

</agm-map>
